import SpinModel from "../../../../vendor_core/core/src/model/SpinModel";
import { ICondition } from "../../../../vendor_core/core/src/states/State";

export class BBFreeSpinsWonCondition implements ICondition {
    public check(): boolean {
        if(SpinModel.isInFreespins()){
            return false
        }else {
            if(SpinModel.cascades?.length == 0) {
                return SpinModel.hasFreespinsWon();
            }else {
                if(SpinModel.cascadeIndex == SpinModel.cascades.length){
                    return SpinModel.hasFreespinsWon();
                }
            }
        }
    }
}